define([
    'gridComponent/core/enums'
],
function (enums) {
    'use strict';

    const UserSelectionType = enums.UserSelectionType;
    const ROW_BORDER_WIDTH = 'rowDivider_w';

    function GridOptions(props, handlers, state) {
        const hasDataFetcher = state.dataFetchContext !== null;
        const compProp = props.compProp;

        const options = {
            rowBuffer: 0,
            rowHeight: GridOptions.getRowHeight(props),
            paginationOverflowSize: 0,
            paginationPageSize: compProp.pagination.rowsPerPage,
            // For the initial version, we do not allow any UoU sorting or filtering
            enableSorting: false, //compProp.allowUserSorting,
            enableFilter: false, //compProp.allowUserFiltering,
            suppressMovableColumns: true,
            rowSelection: GridOptions.getRowSelection(compProp),
            suppressCellSelection: GridOptions.isCellSelectionSuppressed(compProp),
            enableServerSideSorting: hasDataFetcher,
            enableServerSideFilter: hasDataFetcher,

            onSortChanged: handlers.onSortChanged,
            onFilterChanged: handlers.onUoUFiltersChanged,
            onCellValueChanged: handlers.onCellEdit,
            onRowSelected: handlers.onRowSelect,
            onCellFocused: handlers.onCellSelect,
            rowData: null

            // Optional customisation of the loading overlay:
            // overlayLoadingTemplate: GridOptions.getOverlayLoadingTemplate()
        };

        if (compProp.pagination.type !== enums.PaginationType.NONE) {
            options.rowModelType = compProp.pagination.type;
        }

        return options;
    }

    GridOptions.isCellSelectionSuppressed = function (compProp) {
        return compProp.userSelectionType !== UserSelectionType.CELL;
    };

    GridOptions.getRowHeight = function (props) {
        return props.compProp.rowHeight + (Number(props.compTheme.style.properties[ROW_BORDER_WIDTH]) || 0);
    };

    GridOptions.getRowSelection = function (compProp) {
        if (compProp.userSelectionType === UserSelectionType.ROW) {
            return 'single';
        }
        return undefined;
    };

    // GridOptions.getOverlayLoadingTemplate = function () {
    //     return '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';
    // };

    return GridOptions;
}
);
